/* global dataLayer */

export default {
  handle(event, obj) {
    if (typeof dataLayer === 'undefined') {
      return;
    }

    dataLayer.push({
      event,
      ...obj,
    });
  },

  event(category, action, label, value = 0) {
    this.handle('general_event', {
      general_event_category: category,
      general_event_action: action,
      general_event_label: label,
      general_event_value: value,
    });
  },

  timing(category, value) {
    this.handle('timing', {
      timing_name: category,
      timing_value: value,
    });
  },
};
